export default __webpack_public_path__ + "static/media/ResetAndRemovingMaps.23d7cccd.mp4";